document.addEventListener('DOMContentLoaded', () => {
  const variantInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
  const expiryBox = document.getElementById('variant-offer-expiry');
  const expiryDateEl = expiryBox?.querySelector('.expiry-date');

  if (variantInput && expiryBox && expiryDateEl) {
    const observer = new MutationObserver(() => updateExpiry(variantInput.value));
    observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });

    // Initial run
    updateExpiry(variantInput.value);
  }

  function updateExpiry(variantId) {
    const expiry = expiryBox.getAttribute('data-expiry-' + variantId);
    if (expiry) {
      expiryDateEl.textContent = expiry.replace(/-/g, '.'); // ex: 2026.05.12
      expiryBox.style.display = "flex";
    } else {
      expiryDateEl.textContent = "";
      expiryBox.style.display = "none"; // hide block if no expiry
    }
  }
});
